const category: Record<string, string | Record<string, string>> = {
    categoryListTitle: 'Категории инициатив',
    fields: {
        form: 'Форма инициативы',
        process: 'ЖЦ инициативы',
    },
};

export default category;
